// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cubeTabGroup {
    min-height: 400px;
}

.cubeTabGroup .min-width {
    width: 250px;
}

.dimTabContent {
    padding-top: 5px;
}

::ng-deep .cubeTabGroup .mat-tab-body-content {
    overflow: hidden;
}

.dimListBox {
    margin-right: 5px;
}

.parentNode {
    cursor: default;
}

.childNode {
    cursor: pointer;
}

.titleRow {
    justify-content: space-between;
}

.titleRow > * {
    align-self: center;
}

.clusterStack {
    flex-wrap: wrap;
    align-content: flex-start;
    overflow: auto;
}

.clusterControl {
    margin: 0px 10px 10px 0px;
    align-self: flex-start;
}

.attrChip {
    width: 95% !important;
}

.chipDropDIV {
    height: 32px;
    width: 100%;
}

table, th, td {
    border: 1px solid lightgray;
    border-collapse: collapse;
}

th, td {
    padding: 8px 5px;
    background-color: white;
}

thead th, tr.oddRow td {
    background-color: rgb(234,234,234);
}`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/containercube/containercube.settings.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".cubeTabGroup {\n    min-height: 400px;\n}\n\n.cubeTabGroup .min-width {\n    width: 250px;\n}\n\n.dimTabContent {\n    padding-top: 5px;\n}\n\n::ng-deep .cubeTabGroup .mat-tab-body-content {\n    overflow: hidden;\n}\n\n.dimListBox {\n    margin-right: 5px;\n}\n\n.parentNode {\n    cursor: default;\n}\n\n.childNode {\n    cursor: pointer;\n}\n\n.titleRow {\n    justify-content: space-between;\n}\n\n.titleRow > * {\n    align-self: center;\n}\n\n.clusterStack {\n    flex-wrap: wrap;\n    align-content: flex-start;\n    overflow: auto;\n}\n\n.clusterControl {\n    margin: 0px 10px 10px 0px;\n    align-self: flex-start;\n}\n\n.attrChip {\n    width: 95% !important;\n}\n\n.chipDropDIV {\n    height: 32px;\n    width: 100%;\n}\n\ntable, th, td {\n    border: 1px solid lightgray;\n    border-collapse: collapse;\n}\n\nth, td {\n    padding: 8px 5px;\n    background-color: white;\n}\n\nthead th, tr.oddRow td {\n    background-color: rgb(234,234,234);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
